/**
 * Owner: Masa Bayu
 * File: lexical-adapter.ts
 * Date:Time: 2026-10-05 21:13
 * Description: Fasa 30–31 · header+body → Lexical · folio not editable (WS-15.3).
 */

import {
  $createParagraphNode,
  $getRoot,
  type ElementFormatType,
} from 'lexical';
import type { StructuredPage, UniversalAtom } from '../types';
import { $createUniversalTextNode } from './universal-text-node';

const FORMAT_LEFT: ElementFormatType = 'left';
const FORMAT_JUSTIFY: ElementFormatType = 'justify';

function createParagraphFromAtom(
  atom: UniversalAtom,
  alignment: ElementFormatType,
): void {
  if (atom.type !== 'text') return;

  const paragraph = $createParagraphNode();
  paragraph.setFormat(alignment);

  const textNode = $createUniversalTextNode(atom.textContent ?? '');
  if (atom.font) {
    textNode.setFontFamily(atom.font.family || 'sans-serif');
    textNode.setFontSize(atom.font.size || 12);
    textNode.setFontWeight(atom.font.weight || 400);
  }
  if (atom.color) {
    textNode.setColor(atom.color);
  }

  paragraph.append(textNode);
  $getRoot().append(paragraph);
}

/**
 * Inject StructuredPage text layers into the active Lexical root.
 * Must run inside editor.update(() => { ... }).
 * Header + body only · footerLayer = page furniture (WS-15.3) · not editable.
 * visual/table/list skipped (Fasa 30).
 */
export function populateLexicalRootFromStructuredPage(
  page: StructuredPage,
): void {
  const root = $getRoot();
  root.clear();

  for (const atom of page.headerLayer) {
    createParagraphFromAtom(atom, FORMAT_LEFT);
  }
  for (const atom of page.bodyLayer) {
    createParagraphFromAtom(atom, FORMAT_JUSTIFY);
  }
}
